module.exports = __webpack_public_path__ + "img/Algeria.d89d3f5a.svg";